export type DecodeURLResponse = { s: string, redirect: string };

export const decodeURLParams = (url: string): DecodeURLResponse => {
    const params = new URLSearchParams(url);
    const s = atob(params.get("s") || "");
    const redirect = atob(params.get("r") || ""); 

    return { s, redirect };
};